module.exports = __webpack_public_path__ + "img/404.7c956cc3.png";